export default __webpack_public_path__ + "static/media/cross.1cf43d5a.svg";